import React from "react";
import { Text } from "react-native";

import ChannelListScreen from "../../../screens/Messaging/ChannelListScreen";

import { useSession } from "@/context/auth/useSession";

export default function Page(): React.JSX.Element {
  const { session, isSessionLoading } = useSession();

  if (isSessionLoading) {
    return <Text>Loading...</Text>;
  }

  if (session === undefined || session === null) {
    return <Text>Need to login</Text>;
  }

  return <ChannelListScreen username={session.identity.username} />;
}
